// extracted by mini-css-extract-plugin
module.exports = {"message":"inputError_message__NW7_N","icon":"inputError_icon__5nsxP"};